/* Armazém 11/2026 — feed vertical de Reels (/pages/videos), rodada 3.
   Vídeo: pool de até 3 <video> (anterior, atual, seguinte com preload="metadata" = troca instantânea); quem está a 2+
   células do atual cede o elemento. Toca 1 por vez.
   Som: estado único soundOn (memória + sessionStorage); todo <video> nasce com muted = !soundOn. Se o navegador barrar
   play() com som sem gesto (NotAllowedError, iOS), o estado NÃO desliga: só aquele toca mudo (blocked) e o próximo gesto
   no feed religa. No gesto também "abençoamos" os vizinhos (play mudo + pause dentro do gesto): no WebKit a licença de
   som é por elemento, e um play() dentro de gesto libera o elemento pra sempre.
   Trilho: ❤ localStorage reels_likes (+ data-like-endpoint opcional) · 💬 folha inferior (textContent, nunca innerHTML):
   avaliações de quem comprou (Judge.me, endpoint público, buscadas no clique) + comentários do Instagram
   · ↗ Web Share / WhatsApp. 🛒 é o <product-form> do tema (zero JS aqui).
   Início: #reel-<id> > sessionStorage.reels_last (mesma aba: volta onde parou) > rotação por visita (script inline no Liquid). */
if (!customElements.get('reels-feed')) {
  const fmt = (n) => {
    n = +n || 0;
    if (n >= 1e6) return String(Math.floor(n / 1e5) / 10).replace('.', ',') + ' mi';
    if (n >= 1e3) return String(Math.floor(n / 100) / 10).replace('.', ',') + ' mil';
    return String(n);
  };
  const MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
  const dataCurta = (d) => {
    const p = String(d || '').split('-');
    if (p.length < 3) return '';
    const ano = String(new Date().getFullYear()) === p[0] ? '' : ' ' + p[0].slice(2);
    return +p[2] + ' ' + (MESES[+p[1] - 1] || '') + ano;
  };
  const lerLikes = () => {
    try {
      return JSON.parse(localStorage.getItem('reels_likes')) || {};
    } catch (e) {
      return {};
    }
  };

  customElements.define(
    'reels-feed',
    class ReelsFeed extends HTMLElement {
      connectedCallback() {
        this.cells = Array.from(this.querySelectorAll('.reels-feed__cell'));
        this.cells.forEach((cell, i) => (cell.dataset.i = i));
        this.pool = [];
        this.current = null;
        this.blocked = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const conn = navigator.connection;
        this.sd = !!(conn && (conn.saveData || /2g|3g/.test(conn.effectiveType))); // rede lenta: mp4 480 se a célula tiver
        let sound = false;
        try {
          sound = sessionStorage.getItem('reels_sound') !== '0'; // pedido 03/11: entra com som; se o navegador barrar, fica 'blocked' até o 1º toque
        } catch (e) {}
        this.setSound(sound, false);

        this.likes = lerLikes();
        this.cells.forEach((cell) => this.renderCounts(cell));

        this.io = new IntersectionObserver(this.onIntersect.bind(this), { threshold: [0, 0.6] });
        this.cells.forEach((cell) => this.io.observe(cell));

        this.addEventListener('click', this.onClick.bind(this));
        // Gesto real (toque solto, clique, tecla) = licença pra som. Scroll não conta.
        this.onGesture = this.onGesture.bind(this);
        ['pointerup', 'touchend', 'keydown'].forEach((t) => this.addEventListener(t, this.onGesture, { passive: true }));

        // Quick view (modal-dialog) pausa todo <video> ao abrir (pauseAllMedia); retoma o visível no close.
        this.onQuickView = () => {
          const modal = document.getElementById('QuickView-Modal');
          if (!modal) return;
          modal.addEventListener('close', () => {
            // quick-view.js guarda a modal fechada e chama hide() em TODO cartUpdate: focus() no botão da célula
            // antiga (o feed pula pra lá) + pauseAllMedia. Modal morta vira inerte.
            modal.hide = () => {};
            this.resume();
          }, { once: true });
        };
        document.addEventListener('quick-view:loaded', this.onQuickView);

        // Voltar da página do produto (bfcache) deixa o vídeo parado.
        this.onPageShow = (e) => e.persisted && this.play(this.current);
        window.addEventListener('pageshow', this.onPageShow);

        const back = this.parentElement && this.parentElement.querySelector('.reels-feed__back');
        if (back) {
          back.addEventListener('click', (e) => {
            let mesma = false;
            try {
              mesma = !!document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1;
            } catch (err) {}
            if (mesma) {
              e.preventDefault();
              history.back();
            }
          });
        }
        this.sheet = this.parentElement && this.parentElement.querySelector('.reels-sheet');
        if (this.sheet) this.initSheet();

        this.goToHash();
      }

      disconnectedCallback() {
        this.io && this.io.disconnect();
        document.removeEventListener('quick-view:loaded', this.onQuickView);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      // #reel-<id>: rola SÓ o feed (scrollIntoView também rolaria a página e desalinharia a barra).
      goToHash() {
        let id = location.hash.slice(1);
        if (!id) {
          try {
            id = sessionStorage.getItem('reels_last') || ''; // mesma aba (voltou do produto/carrinho/home): segue de onde parou
          } catch (e) {}
        }
        const cell = id && document.getElementById(id);
        if (!cell || !this.contains(cell)) return;
        const align = () => {
          this.scrollTop += cell.getBoundingClientRect().top - this.getBoundingClientRect().top;
          window.scrollTo(0, 0);
        };
        align();
        window.addEventListener('load', align, { once: true });
      }

      onIntersect(entries) {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.6) this.activate(entry.target);
          else this.pause(entry.target);
        });
      }

      /* ---------- vídeo ---------- */
      activate(cell) {
        if (this.current && this.current !== cell) this.pause(this.current);
        this.current = cell;
        try {
          sessionStorage.setItem('reels_last', 'reel-' + cell.dataset.id); // pro "Voltar aos vídeos" na página do produto
          const seen = JSON.parse(localStorage.getItem('reels_seen')) || {}; // bolinhas da home: anel laranja some
          seen[cell.dataset.id] = 1;
          localStorage.setItem('reels_seen', JSON.stringify(seen));
        } catch (e) {}
        const start = () => {
          if (this.current !== cell) return;
          this.attach(cell, 'auto');
          if (!this.reduced) this.play(cell);
          const next = this.cells[+cell.dataset.i + 1];
          if (next) this.attach(next, 'metadata'); // o seguinte já pronto: troca instantânea
        };
        // 1º vídeo da visita: a capa é a maior imagem da tela (LCP) e perderia a banda pro mp4 de 3 MB — espera ela
        // chegar (no máximo 1,2 s) e só então liga o vídeo. Em rede boa a capa já está pronta e nada muda.
        const cover = cell.querySelector('.reels-feed__cover');
        if (!this.started && cover && !cover.complete) {
          this.started = true;
          let done = false;
          const go = () => {
            if (done) return;
            done = true;
            start();
          };
          cover.addEventListener('load', go, { once: true });
          cover.addEventListener('error', go, { once: true });
          setTimeout(go, 1200);
          return;
        }
        this.started = true;
        start();
      }

      attach(cell, preload) {
        let video = cell._v;
        if (!video) {
          video = this.take(cell);
          video.preload = preload;
          video.poster = cell.dataset.poster;
          video.src = (this.sd && cell.dataset.srcSd) || cell.dataset.src;
          video.muted = !this.soundOn;
          cell._v = video;
          cell.insertBefore(video, cell.querySelector('.reels-feed__overlay'));
        } else if (preload === 'auto' && video.preload !== 'auto') {
          video.preload = 'auto';
        }
        return video;
      }

      // Pool de 3: cria até 3; depois reaproveita o elemento de vídeo mais longe do atual (2+ células). A capa (imagem) fica.
      take(cell) {
        if (this.pool.length < 3) {
          const video = document.createElement('video');
          video.setAttribute('playsinline', '');
          video.playsInline = true;
          video.loop = true;
          video.muted = !this.soundOn;
          if (this.reduced) video.controls = true;
          // barra de progresso da célula dona (o <video> troca de célula; lê o pai na hora)
          video.addEventListener('timeupdate', () => {
            const c = video.parentElement;
            if (c && video.duration) c.style.setProperty('--reels-p', String(video.currentTime / video.duration));
          });
          this.pool.push(video);
          return video;
        }
        const cur = this.current ? +this.current.dataset.i : +cell.dataset.i;
        let best = this.pool[0];
        let bestD = -1;
        this.pool.forEach((v) => {
          const owner = v.parentElement;
          const d = owner ? Math.abs(+owner.dataset.i - cur) : 99;
          if (d > bestD) {
            bestD = d;
            best = v;
          }
        });
        const owner = best.parentElement;
        best.pause();
        if (owner) {
          owner._v = null;
          owner.style.removeProperty('--reels-p');
        }
        return best;
      }

      pause(cell) {
        const video = cell && cell._v;
        video && video.pause();
      }

      play(cell) {
        const video = cell && cell._v;
        if (!video) return;
        video.muted = !this.soundOn;
        const promise = video.play();
        if (!promise) return;
        promise.catch((err) => {
          // Só bloqueio de autoplay. AbortError (pause()/src trocado no meio) não é bloqueio: nada a fazer.
          if (!err || err.name !== 'NotAllowedError') return;
          if (video.muted) {
            video.setAttribute('controls', ''); // nem mudo pôde tocar (economia de bateria etc.): controles nativos
            return;
          }
          // Som barrado sem gesto (iOS): toca mudo SÓ este; o estado continua ligado e o próximo toque religa.
          this.blocked = true;
          this.syncSound();
          video.muted = true;
          video.play().catch(() => video.setAttribute('controls', ''));
        });
      }

      resume() {
        // Depois de "adicionar ao carrinho" a gaveta abre por cima: espera ela fechar.
        const drawer = document.querySelector('drawer-component[open]');
        if (drawer) drawer.addEventListener('close', () => this.play(this.current), { once: true });
        else this.play(this.current);
      }

      /* ---------- som ---------- */
      setSound(on, store) {
        this.soundOn = on;
        this.blocked = false;
        this.syncSound();
        const video = this.current && this.current._v;
        if (video) {
          video.muted = !on;
          if (on && video.paused && !this.reduced) this.play(this.current);
        }
        if (store) {
          try {
            sessionStorage.setItem('reels_sound', on ? '1' : '0');
          } catch (e) {}
        }
      }

      syncSound() {
        this.dataset.sound = !this.soundOn ? 'off' : this.blocked ? 'blocked' : 'on';
        this.querySelectorAll('.reels-feed__sound').forEach((b) =>
          b.setAttribute('aria-pressed', this.soundOn ? 'true' : 'false')
        );
      }

      // Dentro de um gesto: religa o som do atual (se barrado) e libera os vizinhos pro som.
      onGesture() {
        if (!this.soundOn) return;
        if (this.blocked) this.unblock();
        this.pool.forEach((v) => v.parentElement !== this.current && this.bless(v));
      }

      unblock() {
        this.blocked = false;
        this.syncSound();
        this.repairedAt = Date.now();
        this.play(this.current); // no gesto: com som; se falhar, play() volta a mudo + blocked
      }

      // play() mudo + pause() dentro do gesto: o WebKit solta a trava de som do elemento (vale até ele ser destruído).
      bless(video) {
        if (!video || video._blessed || video._blessing || !video.src) return;
        video._blessing = true;
        video.muted = true;
        const promise = video.play();
        if (!promise) {
          video._blessing = false;
          return;
        }
        promise
          .then(() => (video._blessed = true))
          .catch(() => {})
          .then(() => {
            video._blessing = false;
            const cell = video.parentElement;
            if (cell === this.current) {
              this.play(cell); // virou o atual nesse meio-tempo: toca de verdade
              return;
            }
            video.pause();
            try {
              video.currentTime = 0;
            } catch (e) {}
            video.muted = !this.soundOn;
          });
      }

      /* ---------- cliques ---------- */
      onClick(e) {
        const t = e.target;
        if (t.closest('.reels-feed__sound')) {
          if (Date.now() - (this.repairedAt || 0) < 600) return; // o pointerup deste toque já religou o som barrado
          if (!this.soundOn) {
            this.setSound(true, true);
            this.pool.forEach((v) => v.parentElement !== this.current && this.bless(v));
          } else this.setSound(false, true);
          return;
        }
        const act = t.closest('[data-action]');
        if (act) {
          const cell = act.closest('.reels-feed__cell');
          const a = act.dataset.action;
          if (a === 'like') this.like(cell, act);
          else if (a === 'comments') this.openSheet(cell, act);
          else if (a === 'share') this.share(cell);
          return;
        }
        if (t.closest('a, button, product-form')) return; // CTA, links e carrinho: o tema cuida
        const media = t.closest('video, .reels-feed__cover');
        if (!media) return;
        if (Date.now() - (this.repairedAt || 0) < 600) return; // esse toque foi pra religar o som, não pra pausar
        const cell = media.closest('.reels-feed__cell');
        const video = cell._v;
        if (video && video.controls) return; // controles nativos cuidam do toque
        if (!video) this.activate(cell);
        else if (video.paused) this.play(cell);
        else video.pause();
      }

      /* ---------- ❤ ---------- */
      renderCounts(cell) {
        const liked = !!this.likes[cell.dataset.id];
        const likeBtn = cell.querySelector('[data-action="like"]');
        if (likeBtn) {
          likeBtn.setAttribute('aria-pressed', liked ? 'true' : 'false');
          likeBtn.classList.toggle('is-liked', liked);
          likeBtn.querySelector('[data-count]').textContent = fmt((+cell.dataset.likes || 0) + (liked ? 1 : 0));
        }
        const c = cell.querySelector('[data-action="comments"] [data-count]');
        if (c) c.textContent = fmt(cell.dataset.commentsN);
      }

      like(cell, btn) {
        const id = cell.dataset.id;
        const liked = !this.likes[id];
        const d = cell.dataset;
        if (liked) this.likes[id] = d.handle ? { handle: d.handle, variant: +d.variant || null, title: d.title || '', image: d.image || '', price: d.price || '', at: new Date().toISOString() } : 1;
        else delete this.likes[id];
        if (liked && d.handle) this.toast('Salvo em Curtidos', this.dataset.curtidosUrl || '/pages/videos?view=curtidos', 'Ver');
        try {
          localStorage.setItem('reels_likes', JSON.stringify(this.likes));
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('reels:likes')); // bolinha do ❤ no cabeçalho/barra (curtidos-badge.js)
        this.renderCounts(cell);
        btn.classList.remove('is-pop');
        void btn.offsetWidth; // reinicia a animação
        btn.classList.add('is-pop');
        const url = this.dataset.likeEndpoint; // backend de curtidas vem depois; sem URL, fica só no aparelho
        if (url) {
          fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ reel: id, liked: liked }),
            keepalive: true,
          }).catch(() => {});
        }
      }

      toast(text, href, linkText) {
        let t = this.querySelector('.reels-feed__toast');
        if (!t) {
          t = document.createElement('div');
          t.className = 'reels-feed__toast';
          t.setAttribute('role', 'status');
          this.appendChild(t);
        }
        t.textContent = text + ' · ';
        const a = document.createElement('a');
        a.href = href;
        a.textContent = linkText;
        t.appendChild(a);
        t.classList.add('is-on');
        clearTimeout(this._toastT);
        this._toastT = setTimeout(() => t.classList.remove('is-on'), 2600);
      }

      /* ---------- ↗ ---------- */
      share(cell) {
        const title = cell.dataset.title || document.title;
        const url = cell.dataset.shareUrl || location.href;
        const text = 'Olha esse ' + title + ' no Armazém dos Chinelos';
        if (navigator.share) navigator.share({ title: title, text: text, url: url }).catch(() => {});
        else window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank', 'noopener');
      }

      /* ---------- 💬 folha inferior ---------- */
      initSheet() {
        const sheet = this.sheet;
        const panel = sheet.querySelector('.reels-sheet__panel');
        const head = sheet.querySelector('.reels-sheet__head');
        sheet.addEventListener('click', (e) => e.target.closest('[data-sheet-close]') && this.closeSheet());
        sheet.addEventListener('keydown', (e) => e.key === 'Escape' && this.closeSheet());
        // Arrastar o topo pra baixo fecha (>80px); senão volta pro lugar.
        let y0 = null;
        head.addEventListener('pointerdown', (e) => {
          if (e.target.closest('[data-sheet-close]')) return; // o X fecha pelo click; capturar o ponteiro roubaria o click
          y0 = e.clientY;
          head.setPointerCapture(e.pointerId);
          panel.style.transition = 'none';
        });
        head.addEventListener('pointermove', (e) => {
          if (y0 !== null) panel.style.transform = 'translateY(' + Math.max(0, e.clientY - y0) + 'px)';
        });
        const end = (e) => {
          if (y0 === null) return;
          const dy = e.clientY - y0;
          y0 = null;
          panel.style.transition = '';
          panel.style.transform = '';
          if (dy > 80) this.closeSheet();
        };
        head.addEventListener('pointerup', end);
        head.addEventListener('pointercancel', end);
      }

      openSheet(cell, opener) {
        const sheet = this.sheet;
        if (!sheet) return;
        // Comentários do Instagram (data-comments da célula)
        let items = [];
        try {
          items = JSON.parse(cell.dataset.comments || '[]') || [];
        } catch (e) {}
        const list = sheet.querySelector('[data-ig-list]');
        list.textContent = '';
        items.forEach((c) => {
          if (!c || !c.t) return;
          const li = document.createElement('li');
          li.className = 'reels-sheet__item';
          const p = document.createElement('p');
          p.className = 'reels-sheet__text';
          const b = document.createElement('b');
          b.textContent = c.u || 'instagram';
          p.appendChild(b);
          p.appendChild(document.createTextNode(' ' + c.t));
          const meta = document.createElement('p');
          meta.className = 'reels-sheet__meta';
          meta.textContent = '♥ ' + fmt(c.l) + (c.d ? ' · ' + dataCurta(c.d) : '');
          li.appendChild(p);
          li.appendChild(meta);
          list.appendChild(li);
        });
        sheet.querySelector('[data-ig-empty]').hidden = list.children.length > 0;
        sheet.querySelector('[data-ig-n]').textContent = fmt(cell.dataset.commentsN || list.children.length);
        // Avaliações de quem comprou (Judge.me) — só quando a célula tem produto
        const sec = sheet.querySelector('[data-sec="reviews"]');
        sec.hidden = !cell.dataset.productId;
        if (cell.dataset.productId) this.loadReviews(cell, sec);
        this.sheetOpener = opener;
        sheet.hidden = false;
        sheet.querySelector('.reels-sheet__body').scrollTop = 0;
        requestAnimationFrame(() => sheet.classList.add('is-open'));
        sheet.querySelector('.reels-sheet__panel').focus({ preventScroll: true });
        // O vídeo continua tocando atrás, como no Instagram.
      }

      /* Judge.me: o mesmo endpoint público que o widget da página do produto usa (CORS liberado). O HTML deles entra
         num DOMParser e só TEXTO sai pra tela (textContent); fotos só de judge.me / cdn.shopify.com. 1 busca por célula. */
      loadReviews(cell, sec) {
        const d = cell.dataset;
        const n = +d.jmN || 0;
        const link = sec.querySelector('[data-reviews-link]');
        link.hidden = !d.reviewsUrl;
        if (d.reviewsUrl) link.href = d.reviewsUrl;
        const avg = sec.querySelector('[data-reviews-avg]');
        avg.hidden = !n;
        if (n) avg.textContent = '★ ' + String(d.jmAvg || '').replace('.', ',') + ' de 5 · ' + fmt(n) + (n === 1 ? ' avaliação' : ' avaliações');
        const ul = sec.querySelector('[data-reviews-list]');
        const show = (k) => ['loading', 'empty', 'error'].forEach((x) => (sec.querySelector('[data-reviews-' + x + ']').hidden = x !== k));
        const title = (d.title || '').trim(); // Judge.me põe o nome do produto como texto quando a pessoa só dá as estrelas
        if (cell._reviews) {
          this.renderReviews(ul, cell._reviews, title);
          show(cell._reviews.length ? '' : 'empty');
          return;
        }
        ul.textContent = '';
        if (!n) {
          show('empty');
          return;
        }
        show('loading');
        const shop = this.dataset.shop || location.hostname;
        const url =
          'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) +
          '&platform=shopify&product_id=' + encodeURIComponent(d.productId) + '&page=1&per_page=10';
        fetch(url, { mode: 'cors', credentials: 'omit' })
          .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
          .then((j) => {
            const doc = new DOMParser().parseFromString(String(j.html || ''), 'text/html');
            const revs = Array.from(doc.querySelectorAll('.jdgm-rev'))
              .map((el) => {
                const text = (q) => ((el.querySelector(q) || {}).textContent || '').replace(/\s+/g, ' ').trim();
                const rating = el.querySelector('.jdgm-rev__rating');
                const time = el.querySelector('time');
                const pics = Array.from(el.querySelectorAll('.jdgm-rev__pics img'))
                  .map((img) => img.getAttribute('src') || img.getAttribute('data-src') || '')
                  .filter((u) => /^https:\/\/([a-z0-9-]+\.)*(judge\.me|shopify\.com)\//i.test(u))
                  .slice(0, 3);
                return {
                  s: Math.max(0, Math.min(5, rating ? +rating.getAttribute('data-score') || 0 : 0)),
                  u: text('.jdgm-rev__author'),
                  h: text('.jdgm-rev__title'),
                  t: text('.jdgm-rev__body'),
                  d: time ? (time.getAttribute('datetime') || '').slice(0, 10) : '',
                  v: el.getAttribute('data-verified-buyer') === 'true',
                  p: pics,
                };
              })
              .filter((r) => r.s || r.t);
            cell._reviews = revs;
            if (this.sheet.hidden) return;
            this.renderReviews(ul, revs, title);
            show(revs.length ? '' : 'empty');
          })
          .catch(() => {
            if (!this.sheet.hidden) show('error');
          });
      }

      renderReviews(ul, revs, title) {
        ul.textContent = '';
        revs.forEach((r) => {
          if (title && r.t === title) r = Object.assign({}, r, { t: '' }); // só estrelas: não repete o nome do produto
          const li = document.createElement('li');
          li.className = 'reels-sheet__item reels-sheet__review';
          const head = document.createElement('p');
          head.className = 'reels-sheet__text';
          const stars = document.createElement('span');
          stars.className = 'reels-sheet__stars';
          stars.setAttribute('aria-label', r.s + ' de 5');
          stars.textContent = '★★★★★'.slice(0, r.s) + '☆☆☆☆☆'.slice(0, 5 - r.s);
          head.appendChild(stars);
          const b = document.createElement('b');
          b.textContent = ' ' + (r.u || 'Cliente');
          head.appendChild(b);
          if (r.v) {
            const v = document.createElement('span');
            v.className = 'reels-sheet__verified';
            v.textContent = 'Compra verificada';
            head.appendChild(v);
          }
          li.appendChild(head);
          if (r.h || r.t) {
            const p = document.createElement('p');
            p.className = 'reels-sheet__text';
            p.textContent = r.h && r.t && r.h !== r.t ? r.h + ' — ' + r.t : r.h || r.t;
            li.appendChild(p);
          }
          if (r.p.length) {
            const row = document.createElement('div');
            row.className = 'reels-sheet__pics';
            r.p.forEach((u) => {
              const img = document.createElement('img');
              img.src = u;
              img.alt = '';
              img.loading = 'lazy';
              img.width = 56;
              img.height = 56;
              row.appendChild(img);
            });
            li.appendChild(row);
          }
          if (r.d) {
            const meta = document.createElement('p');
            meta.className = 'reels-sheet__meta';
            meta.textContent = dataCurta(r.d);
            li.appendChild(meta);
          }
          ul.appendChild(li);
        });
      }

      closeSheet() {
        const sheet = this.sheet;
        if (!sheet || sheet.hidden) return;
        sheet.classList.remove('is-open');
        setTimeout(() => (sheet.hidden = true), this.reduced ? 0 : 250);
        if (this.sheetOpener) this.sheetOpener.focus({ preventScroll: true });
      }
    }
  );
}
